import React, { useState, useEffect } from 'react';
import { Tooltip } from '@material-ui/core';
import HelpCircleOutlineIcon from 'mdi-react/HelpCircleOutlineIcon';
import { _axiosCall } from '../helpers/apicalls';
import { _formatNumber } from '../helpers/utils';
import { _fetchPiedATerreRoll, _getPiedATerreStatus } from '../helpers/piedATerre';

const apiURL = process.env.API_ROOT + '/query/';

/**
 * Flags a property whose DOF market value reaches the pied-à-terre surcharge threshold.
 * Says "meets threshold", never "subject": value is only one of the tests, and the
 * exemptions that decide the rest are not in DOF data. The full breakdown, including
 * those exemptions, lives in the Taxes tab (PiedATerreSurcharge).
 */
export default function PiedATerreBadge({ property, onClick }) {
	const [status, setStatus] = useState(false);

	useEffect(() => {
		let cancelled = false;
		if(!property || !property.key) return undefined;
		_fetchPiedATerreRoll(_axiosCall, apiURL, property).then(({ roll, isCoopUnit }) => {
			if(cancelled || !roll) return;
			const patStatus = _getPiedATerreStatus(property, roll, isCoopUnit);
			if(patStatus && patStatus.meetsThreshold) setStatus(patStatus);
		});
		return () => { cancelled = true; };
	}, [property && property.key]);

	if(!status) return null;

	// Whether this particular unit owes anything turns on how it is used, so the hover
	// names the exemptions instead of stating the surcharge as a fact.
	const tooltip = `Meets the $${_formatNumber(status.threshold)} threshold —`
		+ ` about $${_formatNumber(status.amount)} unless this unit is exempt`
		+ ' (primary residence, year-plus lease, or sponsor-held).';

	return (
		<Tooltip title={tooltip} placement="top">
			<span
				className="pied-a-terre-badge"
				onClick={onClick}
				role={onClick ? 'button' : undefined}
				style={onClick ? { cursor: 'pointer' } : undefined}
			>
				Meets Pied-à-Terre Threshold
				<HelpCircleOutlineIcon size={12} className="pied-a-terre-badge__help" />
			</span>
		</Tooltip>
	);
}
